<script lang="ts" setup>
import { i18n } from '@apps/main/modules/localization/localizationSetup';

import { getHumanizedDuration } from '@libs/utils';

interface FlightStopoverProps {
  stopover: number;
}

const { t } = i18n.global;

const props = defineProps<FlightStopoverProps>();
</script>

<template>
  <div class="flight-stopover">
    <div class="flight-stopover-durration">
      {{
        `${t('planner.stopover')}: ${getHumanizedDuration(
          props.stopover,
          'minute'
        )}`
      }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
.flight-stopover {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-left: var(--spacing-8);
  margin-top: var(--spacing-8);
  border-left: 1px dashed var(--color-neutral-70);
  padding-left: var(--spacing-24);
  height: 60px;

  .flight-stopover-durration {
    @include font-label-m-bold;
  }
}
</style>
